import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import SystemSettings from '../../components/SystemSettings/SystemSettings';

export const SettingsRouting = (props: LogicalRouteImportProps) => {
    const disabled = !useHasPermissions({ permission: Pages.SETTINGS, role: Roles.VIEWER });

    return <LogicalRoute {...props} component={SystemSettings} disabled={disabled} />;
};
